<template>
  <div>
    <v-container fluid style="margin-top:0px;margin-bottom:0px">
      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service, name_filter, (current_page - 1) * $store.state.config.items_per_page)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <!--Filter-->
      <div class="row mb-3" v-if="list_access">
        <div class="col-md-12">
          <div class="filter">
            <div class="d-flex align-items-center">
              <h4 class="title">{{ $t("Filtros") }}</h4>
              <font-awesome-icon icon="filter" />
            </div>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <v-text-field data-vv-as="nombre" :label="$t('Nombre')" name="type" v-model="name_filter"></v-text-field>
              </div>
              <div class="col-md-4">
                <v-checkbox :label="$t('Activo')" v-model="active_filter"></v-checkbox>
              </div>

              <div class="col-md-4 d-flex align-items-center justify-content-end pr-10">
                <v-btn color="primary" dark v-on="on" @click="loadList(service)">{{ $t("Buscar") }}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Filter -->

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" :label="$t('Buscar')" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" :loading-text="$t('cargando_espere')" hide-default-footer disable-pagination>
          <template v-slot:item="props">
            <tr>
              <td>
                {{ (pagination.page - 1) * pagination.itemsPerPage + props.index + 1 }}
              </td>
              <td>{{ props.item.nameSubClient }}</td>
              <td>{{ props.item.externalCode }}</td>
              <td>{{ props.item.province.name }}</td>
              <td>{{ props.item.locality.name }}</td>
              <td>{{ props.item.subClientAddress }}</td>
              <td>{{ props.item.subClientTelephone }}</td>
              <td class="text-center">
                {{ props.item.latitudAddress != null && props.item.longitudAddress != null ? "SI" : "NO" }}
              </td>
              <td class="text-center">
                {{ props.item.communicationEnabled ? "SI" : "NO" }}
              </td>
              <td class="text-center">
                <v-chip 
                  v-if="props.item.deliveryTimeFrom1 && props.item.deliveryTimeTo1" 
                  small 
                  color="primary" 
                  outlined
                  class="mr-1 mb-1"
                >
                  {{ formatTime(props.item.deliveryTimeFrom1) }} - {{ formatTime(props.item.deliveryTimeTo1) }}
                </v-chip>
                <v-chip 
                  v-if="props.item.deliveryTimeFrom2 && props.item.deliveryTimeTo2" 
                  small 
                  color="primary" 
                  outlined
                  class="mb-1"
                >
                  {{ formatTime(props.item.deliveryTimeFrom2) }} - {{ formatTime(props.item.deliveryTimeTo2) }}
                </v-chip>
                <span v-if="!props.item.deliveryTimeFrom1 && !props.item.deliveryTimeFrom2">-</span>
              </td>
              <td class="text-center">
                {{ props.item.unloadingTime ? props.item.unloadingTime + ' min' : '-' }}
              </td>
              <td class="text-center px-0">
                <v-tooltip bottom v-if="update_access">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)">
                      edit
                    </v-icon>
                  </template>
                  <span>{{ $t("Editar") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(props.item)">
                      remove_red_eye
                    </v-icon>
                  </template>
                  <span>{{ $t("Ver") }}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning"> {{ $t("sin_resultados") + search }}". </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <div v-if="cant_pages > 1" class="text-center">
        <v-pagination
          class="mt-5 mb-5"
          v-model="current_page"
          :length="cant_pages"
          total-visible="10"
          circle
          @next="loadPage(service)"
          @previous="loadPage(service)"
          @input="loadPage(service)"
        ></v-pagination>
      </div>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import { subClientService } from "@/libs/ws/subClientService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./ModalSubcliente.vue";
import RolMixin from "@/mixins/RolMixin.vue";
export default {
  components: { Modal, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      parent: this,
      service: subClientService,
      page_title: "Subclientes",
      modal_title: "Subcliente",
      mainItem: {
        id: "",
        contact: "",
        country: "",
        cuit: "",
        idOrganizacion: "",
        locality: "",
        nameSubClient: "",
        province: "",
        subClientAddress: "",
        subClientEmail: "",
        subClientTelephone: "",
        externalCode: "",
        isActive: true,
        communicationEnabled: true,
        deliveryTimeFrom1: "",
        deliveryTimeTo1: "",
        deliveryTimeFrom2: "",
        deliveryTimeTo2: "",
        unloadingTime: 45,
      },
      defaultItem: null,
      headers: [
        { text: this.$t("Numero"), value: "number" },
        {
          text: this.$t("Nombre"),
          align: "left",
          sortable: true,
          value: "nameSubClient",
        },
        {
          text: this.$t("Codigo_externo"),
          align: "left",
          sortable: true,
          value: "external_code",
        },
        {
          text: this.$t("Provincia"),
          align: "left",
          sortable: true,
          value: "province.name",
        },
        {
          text: this.$t("Localidad"),
          align: "left",
          sortable: true,
          value: "locality.name",
        },
        {
          text: this.$t("Direccion"),
          align: "left",
          sortable: true,
          value: "subClientAddress",
        },
        {
          text: this.$t("Telefono"),
          align: "left",
          sortable: true,
          value: "subClientTelephone",
        },
        {
          text: "Geoposicionamiento",
          align: "center",
          sortable: true,
          value: "",
        },
        {
          text: "Notificar remitos en Ruta",
          align: "center",
          sortable: true,
          value: "",
        },
        {
          text: "Ventana horaria",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "T. Descarga",
          align: "center",
          sortable: true,
          value: "unloadingTime",
        },
        { text: this.$t("Accion"), value: "enable", align: "center" },
      ],
      list: [],
    };
  },
  mounted() {
    this.defaultItem = Object.assign({}, this.mainItem);
    this.loadList(this.service);
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service);
    },
    formatTime(time) {
      if (!time) return '';
      return time.length > 5 ? time.substring(0, 5) : time;
    },
  },
};
</script>
